// test54
(54 && 0);
